<template>
  <div id="app">
    <Header />
    <main>
      <Hero />
      <HowItWorks />
      <WaitlistForm />
      <div class="separator">
        <img src="/assets/blue-separator.svg" alt="Decorative separator" class="separator-image" />
      </div>
      <FAQ />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import HowItWorks from '@/components/HowItWorks.vue'
import WaitlistForm from '@/components/WaitlistForm.vue'
import FAQ from '@/components/FAQ.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Hero,
    HowItWorks,
    WaitlistForm,
    FAQ,
    Footer
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

.separator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  background: white;
}

.separator-image {
  width: 385.333px;
  height: 16px;
}
</style>
